import { render, staticRenderFns } from "./GroupOptimizationHistory.vue?vue&type=template&id=e12de446&scoped=true"
import script from "./GroupOptimizationHistory.vue?vue&type=script&lang=js"
export * from "./GroupOptimizationHistory.vue?vue&type=script&lang=js"
import style0 from "./GroupOptimizationHistory.vue?vue&type=style&index=0&id=e12de446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12de446",
  null
  
)

export default component.exports